export default __webpack_public_path__ + "static/mayabari-7-1e66c18fea86e7130a6056c87132e37c.jpg";